export default "<notifier-container></notifier-container>\r\n<ngx-ui-loader></ngx-ui-loader>\r\n\r\n<router-outlet></router-outlet>"